module.exports = __webpack_public_path__ + "static/img/media_02.6eb6572.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/media_02.png
// module id = pwpW
// module chunks = 0